export const PRICING_OPTION_OPTIONS = [
  { value: '', label: 'Not set' },
  { value: 'rrp', label: 'RRP' },
  { value: 'markeup', label: 'Markup' },
];
